import {ScrollTrigger} from "gsap/ScrollTrigger";
import {scrollToId, smoothScrollPause, smoothScrollPlay} from "../scroll-smoother";
import gsap from "gsap/gsap-core";
import {breakpointUp} from "../utils/breakpoints";

$(document).ready(function () {

  if ($('.news-block')) {
    $('.js--change-news-category li').on('click', function () {
      $('.js--change-news-category li').removeClass('active-element');
      $(`[data-news-category="${$(this).data('news-category')}"]`).addClass('active-element');
      window.scrollTo(0, 0);
    });

    $('.js--change-news-year').on('click', function () {
      const filterByYearButton = $('.js--year-filter-button')

      $('.js--change-news-year').removeClass('active-element');
      $(this).addClass('active-element');
      $(`[data-news-year="${$(this).data('news-year')}"]`).addClass('active-element');

      if ($(this).hasClass('single-year')) {
        $('.js--year-filter-button .inner-text').text($(this).text());
        filterByYearButton.parent().addClass('active-element')
      } else {
        $('.js--year-filter-button .inner-text').text(filterByYearButton.data('text'));
        filterByYearButton.parent().removeClass('active-element')
      }
      window.scrollTo(0, 0);
    });
    $('.js--open-news-year-modal, .js--news-open-mobile-filter').on('click', function () {
      const modal = $('.js--news-year-modal')
      modal.addClass('modal-active');
      $('body').addClass('overflow-hidden');
      $('html').addClass('overflow-hidden');
      smoothScrollPause();
    });

    $('.js--news-year-modal .inner-children').on('click', function (event) {
      event.stopPropagation();
    });
    $('.js--news-year-modal .inner-parent, .js--change-news-year, .js--change-news-category li').on('click', function () {
      const modal = $('.js--news-year-modal')
      modal.removeClass('modal-active');
      $('body').removeClass('overflow-hidden');
      $('html').removeClass('overflow-hidden');

      smoothScrollPlay();
    });

    ScrollTrigger.create({
      trigger: '#smooth-wrapper',
      pin: '.js--news-year-modal',
      top: 'top top',
      start: "top-=1000vh top",
      scrub: true,
      pinReparent: true,
      pinType: 'fixed',
      pinSpacing: false,
      endTrigger: 'footer',
      end: 'bottom+=30000vh bottom',
    });
    // if ($(window).width() < 992) {
    //   ScrollTrigger.create({
    //     trigger: '#smooth-wrapper',
    //     pin: '.js--news-open-mobile-filter',
    //     top: 'top top',
    //     start: "top top",
    //     scrub: true,
    //     pinReparent: true,
    //     pinType: 'fixed',
    //     pinSpacing: false,
    //     endTrigger: 'footer',
    //     end: 'bottom+=30000vh bottom',
    //   });
    // }
    initStickyBlock()

    let searchParams = new URLSearchParams(window.location.search)
    let year = searchParams.get('year')
    let category = searchParams.get('category')

    if (year) {
      if (year === '0') return;
      $('.js--change-news-year').removeClass('active-element');
      $('.js--open-news-year-modal').addClass('active-element');
      $('.js--open-news-year-modal button .inner-text').text(year);
      $(`[data-news-year="${year}"]`).addClass('active-element');
    }
    if (category) {
      $(`[data-news-category]`).removeClass('active-element');
      $(`[data-news-category="${category}"]`).addClass('active-element');
    }

  }

  $('.js--copy-news-url').click(function () {
    navigator.clipboard.writeText(window.location.href);

    var tooltip = $('.js--copied-tooltip');
    tooltip.fadeIn(200).delay(2000).fadeOut(200);
  });

  window.initPopupDivider();

});
let st1;
let st2;
window.initStickyBlock = () => {
  const block = document.querySelector('.news-block')

  if (!block) return false

  const triggerElement = block.querySelector('.sticky-block')
  removeScrollTriggers()

  if ($(window).width() > 991) {
    st1 = ScrollTrigger.create({
      trigger: block,
      pin: triggerElement,
      top: 'top top',
      start: $(window).width() >= 1280 ? 'top top' : '-40px top',
      pinType: 'sticky',
      end: 'bottom bottom',
      scrub: false,
    });
  }

  if ($(window).width() < 992) {
    // st2 = ScrollTrigger.create({
    //   trigger: '#smooth-wrapper',
    //   pin: '.js--news-open-mobile-filter',
    //   top: 'top top',
    //   start: "top-=1000vh top",
    //   scrub: true,
    //   pinReparent: true,
    //   pinType: 'fixed',
    //   endTrigger: 'footer',
    //   pinSpacing: false,
    //   end: 'bottom+=30000vh bottom',
    // });

  } else {
    if (st2) {
      st2.kill();
      st2 = null;
    }
  }


  function removeScrollTriggers() {
    if (st1) {
      st1.kill();
      st1 = null;
    }
    if (st2) {
      st2.kill();
      st2 = null;
    }
  }
}

window.animateNewsGrid = () => {
  gsap.fromTo('#news-posts', {y: 15, opacity: 0}, {
    y: 0,
    opacity: 1,
    delay: 0.5,
  });

}


window.initPopupDivider = () => {
  const sections = document.querySelectorAll('.quote-divider');

  sections.forEach(section => {
    section.style.width = '0'; // Initialize width to 0
    section.style.transition = 'width 0.5s'; // Apply transition for smooth animation

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          section.style.width = '100%'; // Animate width to 100% when section enters viewport
        }
      });
    }, {threshold: 0.5});

    observer.observe(section);
  });
};



